import { render, staticRenderFns } from "./garden0.vue?vue&type=template&id=3eb21cc0"
import script from "./garden0.vue?vue&type=script&lang=js"
export * from "./garden0.vue?vue&type=script&lang=js"
import style0 from "./garden0.vue?vue&type=style&index=0&id=3eb21cc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports